import React from 'react';
import {
  TutorCardWrapper as Card,
  TutorInfo as CardInfo,
  TutorName as Title,
  TagWrap,
  Tag,
  NameAndPriceWrapper,
  TutorImage,
  ProfileInitial,
} from '../../styles/search/search.style';
import type { CalendarEvent } from '../../hooks/useEvents';
import { getFirstName, getInitial } from '../../utils/name';

type AvatarInfo = {
  name?: string;
  photoUrl?: string | null;
  color?: string | null;
}
type Props = {
  name: string;
  isTutor: boolean; // when viewing by person, label which side they are
  nextEvent?: CalendarEvent;
  count: number;
  onOpen: () => void;
  avatar?: AvatarInfo;
};

export default function CounterpartyCard({ name, isTutor, nextEvent, count, onOpen, avatar }: Props) {
  const initials = (name: string) => getInitial(name);

  return (
    <Card onClick={onOpen} style={{ cursor: 'pointer' }}>
      {avatar?.photoUrl ? (
        <TutorImage src={avatar.photoUrl} alt={avatar.name || name} />
      ) : (
        <ProfileInitial style={{ backgroundColor: avatar?.color || '#e0e0e0' }}>
          {initials(avatar?.name || name)}
        </ProfileInitial>
      )}
      <CardInfo>
        <NameAndPriceWrapper>
          <Title>
            {getFirstName(name) || (isTutor ? 'Tutor' : 'Parent')}
          </Title>
          <div />
        </NameAndPriceWrapper>

        <TagWrap css={{ marginTop: '0.5rem' }}>
          <Tag isMatch={true}>{count} {count === 1 ? 'event' : 'events'}</Tag>
          {/* {isTutor ? <Tag>tutor</Tag> : <Tag>parent</Tag>} */}
        </TagWrap>
      </CardInfo>
    </Card>
  );
}
